<template lang="pug">
.side-menu
  .side-menu__logo
    image-base(:src='require("@/assets/img/menu_logo.png")')
  .side-menu__role.font-bold.text-xlarge
    slot(name='roleName')
  .side-menu__user-info.font-bold.text-large
    .side-menu__user-info__content
      .side-menu__user-info__content__title
        slot(name='userUidTitle')
      .side-menu__user-info__content__body {{ userUid }}
    .side-menu__user-info__content
      .side-menu__user-info__content__body {{ userName }}
      .side-menu__user-info__content__suffix.text-medium
        slot(name='userNameSuffix')
  .side-menu__links
    template(v-for='linkSetting in linkSettings')
      .side-menu__links__empty(v-if='isEmpty(linkSetting)')
      link-side-menu.side-menu__links__link(:img='iconImg(linkSetting)', @click='linkEvent(linkSetting)', v-else) {{ linkSetting.text }}
  .side-menu__logout
    button-logout.side-menu__logout__button(@click='logoutEvent')
      slot(name='logoutText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import LinkSideMenu from '@/components/molecules/student/LinkSideMenu.vue'
import ButtonLogout from '@/components/molecules/student/ButtonLogout.vue'
import { SideMenuSettings, LinkSetting } from '@/const/SideMenuSettings'

@Component({
  components: {
    ImageBase,
    LinkSideMenu,
    ButtonLogout,
  },
})
export default class SideMenu extends Vue {
  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting
  // リンク設定
  @Prop()
  linkSettings!: LinkSetting[]
  // リンク押下時のイベント
  @Prop()
  linkEvent!: Function
  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // ユーザUID
  private get userUid() {
    return this.$bcbtCookies.authBcbt.get()?.uid || ''
  }
  // ユーザ名
  private get userName() {
    return this.$bcbtCookies.authBcbt.get()?.currentApiUserName || ''
  }

  private isEmpty(linkSetting: LinkSetting): boolean {
    return linkSetting === SideMenuSettings.EMPTY
  }

  private iconImg(linkSetting: LinkSetting): string {
    const iconImg = linkSetting === this.currentLink ? linkSetting.iconActive : linkSetting.iconInactive
    return iconImg || ''
  }
}
</script>

<style lang="stylus" scoped>
.side-menu
  height 100%
  background-color var(--color-side-menu__background)
  padding 20px
  border-radius 10px
  &__logo
    display flex
    justify-content center
    margin-bottom 10px
  &__role
    display flex
    justify-content center
    padding 5px
    color var(--color-side-menu-role__text)
  &__user-info
    margin-bottom 50px
    &__content
      display flex
      align-items flex-end
      &__title
        margin-right 5px
      &__suffix
        margin-left 5px
  &__links
    margin-bottom 50px
    &__link
      margin-bottom 10px
    &__empty
      height 60px
  &__logout
    display flex
    justify-content center
</style>
